import React from 'react';
import VideoCarousel from "../VideoCarousel";

const HomePage = ({ 
  payload, 
  setFile, 
  color,
  config,
  setPlaylist,
  parseSubscriptionTitle 
}) => {
  return config.map((homePageItemName) => {
    // validates if the item is a Playlist
    const isAPlaylist =
      homePageItemName !== "playlists" 
      && homePageItemName !== "live";

    return (
      <VideoCarousel
        key={homePageItemName}
        isAPlaylist={isAPlaylist}
        title={parseSubscriptionTitle(homePageItemName)}
        videos={payload[homePageItemName]}
        category={homePageItemName}
        color={color}
        setPlaylist={setPlaylist}
        setFile={setFile}
      />
    );
  });

}

export default HomePage;